export const DSP_OPTIONS = [
  "DV360", "The Trade Desk", "Yahoo", "Quantcast", "Adform",
  "Adobe", "Amazon", "Eskimi", "Hawk", "Crimtan",
  "Loopme", "Nexxen", "Sqreem", "Stackadapt",
];

export const MEDIA_TYPES = ["Display", "Video", "Native", "Audio"];
export const DEVICES = ["Desktop", "Mobile", "Tablet", "CTV"];
export const ENVIRONMENTS = ["Web", "App"];

export const STATUS_OPTIONS = [
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "delivered", label: "Delivered" },
  { value: "rejected", label: "Rejected" },
];

export const SSP_OPTIONS = [
  "OpenX", "Index Exchange", "Magnite", "Nexxen", "Criteo Commerce Grid",
  "Pubmatic", "Microsoft (Xandr)", "Equativ", "Google", "Inmobi", "Media.Net",
];

export const KPI_OPTIONS = ["CPM", "CPC", "CPA", "CPCV", "Viewability", "CTR", "Other"];

export const COUNTRIES = [
  "Afghanistan", "Albania", "Algeria", "Andorra", "Angola", "Argentina", "Armenia", "Australia", "Austria", "Azerbaijan",
  "Bahrain", "Bangladesh", "Belarus", "Belgium", "Belize", "Benin", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana",
  "Brazil", "Brunei", "Bulgaria", "Burkina Faso", "Cambodia", "Cameroon", "Canada", "Chile", "China", "Colombia",
  "Costa Rica", "Croatia", "Cyprus", "Czech Republic", "Denmark", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Estonia",
  "Ethiopia", "Finland", "France", "Georgia", "Germany", "Ghana", "Greece", "Guatemala", "Honduras", "Hong Kong",
  "Hungary", "Iceland", "India", "Indonesia", "Iraq", "Ireland", "Israel", "Italy", "Ivory Coast", "Jamaica",
  "Japan", "Jordan", "Kazakhstan", "Kenya", "Kuwait", "Latvia", "Lebanon", "Libya", "Lithuania", "Luxembourg",
  "Macau", "Malaysia", "Maldives", "Malta", "Mauritius", "Mexico", "Moldova", "Monaco", "Mongolia", "Montenegro",
  "Morocco", "Mozambique", "Myanmar", "Namibia", "Nepal", "Netherlands", "New Zealand", "Nicaragua", "Nigeria", "North Macedonia",
  "Norway", "Oman", "Pakistan", "Panama", "Paraguay", "Peru", "Philippines", "Poland", "Portugal", "Qatar",
  "Romania", "Russia", "Rwanda", "Saudi Arabia", "Senegal", "Serbia", "Singapore", "Slovakia", "Slovenia", "South Africa",
  "South Korea", "Spain", "Sri Lanka", "Sweden", "Switzerland", "Taiwan", "Tanzania", "Thailand", "Tunisia", "Turkey",
  "UAE", "Uganda", "Ukraine", "United Kingdom", "United States", "Uruguay", "Uzbekistan", "Venezuela", "Vietnam", "Zambia", "Zimbabwe",
];

export const userLabel = (u) => (u ? `${u.name || u.email} (${u.email})${u.company ? ` — ${u.company}` : ""}` : "Unassigned");
